import { Link } from "react-router-dom";
import {
  TbBarbell,
  TbBuildingCommunity,
  TbMoodKid,
  TbSchool,
  TbUserBolt,
  TbYoga,
} from "react-icons/tb";
import { PageSeo } from "../seo";
import { TRIAL_DAYS } from "../../../../constants/trial";
import { AUDIENCE_LEAD, ORG_TYPES, PATHS } from "../nav";
import site from "../site.module.css";
import h from "./home.module.css";
import { formatRub, PageHero, RegisterSection, Title, usePublicPlans } from "./parts";

const ORG_ICONS = {
  fitnes: TbBarbell,
  studii: TbYoga,
  sekcii: TbSchool,
  deti: TbMoodKid,
  trener: TbUserBolt,
  multi: TbBuildingCommunity,
};

const FIT = {
  start: ["Один тренер", "Владелец сам ведёт группы: журнал, расписание, абонементы и учёт оплат."],
  club: ["Секция с командой", "Тренеры со своими кабинетами, приложение для клиентов и онлайн-оплата."],
  scale: ["Крупная школа", "Полный брендинг, лента и соцсеть клуба, до 10 залов и 1 500 клиентов."],
};

export default function AudiencePage() {
  const { plans } = usePublicPlans();

  return (
    <>
      <PageSeo page="audience" />

      <PageHero
        pill="Для кого"
        lines={["Любой клуб.", "Любой вид спорта."]}
        lead={AUDIENCE_LEAD}
        actions={
          <>
            <a href="#register" className={`${site.btn} ${site.btnLg}`}>
              Создать клуб бесплатно
            </a>
            <a href="#organizacii" className={h.link}>
              Кому подходит ↗
            </a>
          </>
        }
        note={`${TRIAL_DAYS} дней полного доступа • без привязки карты`}
        visual={
          <div className={h.collagePhoto}>
            <img src="/landing/niche/gimnastika/hero.jpg" alt="" />
          </div>
        }
      />

      <section className={h.section} id="organizacii">
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>01 / Тип организации</p>
            <Title lines={["Клуб, студия,", "школа или тренер"]} />
            <p className={h.sub}>
              Клуб, студия, школа, секция или тренер.
            </p>
          </div>
          <div className={h.grid3}>
            {ORG_TYPES.map((item) => {
              const Icon = ORG_ICONS[item.id];
              return (
                <article key={item.id} className={h.card}>
                  <span className={`${h.audIcon} ${h.principleIcon}`} aria-hidden>
                    <Icon size={22} />
                  </span>
                  <h3>{item.title}</h3>
                  <p>{item.text}</p>
                </article>
              );
            })}
          </div>
        </div>
      </section>

      <section className={h.section}>
        <div className={h.wrap}>
          <div className={h.head}>
            <p className={h.kicker}>02 / По размеру</p>
            <Title lines={["Тариф подбирается", "по размеру клуба"]} />
          </div>
          <div className={h.grid3}>
            {plans.map((p) => {
              const [who, what] = FIT[p.code] || [];
              if (!who) return null;
              return (
                <article key={p.code} className={h.card}>
                  <span className={h.planTag}>
                    «{p.name}» · {formatRub(p.monthly_price_rub)} ₽ / мес
                  </span>
                  <h3>{who}</h3>
                  <p>{what}</p>
                </article>
              );
            })}
          </div>
          <div className={h.ask}>
            <div>
              <h3>Посчитайте стоимость с модулями</h3>
              <p>Кабинеты, брендинг и соцсеть подключаются к любому тарифу.</p>
            </div>
            <Link to={PATHS.pricing} className={site.btn}>
              Тарифы и модули
            </Link>
          </div>
        </div>
      </section>

      <RegisterSection
        kicker="03 / Регистрация"
        title={["Запустите клуб", "в Бай.Спорт сегодня"]}
      />
    </>
  );
}
